import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function PasswordField({
  label,
  value,
  onChange,
  autoComplete,
  minLength,
  invalid,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete: 'current-password' | 'new-password';
  minLength?: number;
  invalid?: boolean;
}) {
  const { t } = useTranslation('auth');
  const [visible, setVisible] = useState(false);
  return (
    <label className="field">
      <span>{label}</span>
      <div className="password-row">
        <input
          className={`field-input${invalid ? ' field-error' : ''}`}
          type={visible ? 'text' : 'password'}
          autoComplete={autoComplete}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          minLength={minLength}
          maxLength={128}
          required
        />
        <button type="button" className="btn btn-ghost btn-compact" onClick={() => setVisible((v) => !v)}>
          {visible ? t('hidePassword') : t('showPassword')}
        </button>
      </div>
    </label>
  );
}
